<template>
  <div id="Wrapper">
    <Header
      :siteInfo="siteInfo"
    />
    <div class="main_container">
      <Sidebar
        :siteInfo="siteInfo"
      />
      <SettingMain
        v-if="siteInfo !== null && cameraInfo !== null"
        :siteInfo="siteInfo"
        :cameraInfo="cameraInfo"
        @loadFinish="loadFinish"
      />
    </div>
  </div>
</template>
<script>
import Header from '../../components/header/Header'
import Sidebar from '../../components/sidebar/Sidebar'
import SettingMain from '../../components/main/SettingMain'

export default {
  name: 'Setting',
  data: function(){
    return {
    }
  },
  props:{
    siteInfo:{
      type: Array
    },
    cameraInfo:{
      type: Array
    },
  },
  methods: {
    loadFinish() {
      this.$emit('loadFinish');
    },
  },
  components:{
    Header,
    Sidebar,
    SettingMain
  },
}
</script>
<style lang="scss">
</style>